import { connect } from 'react-redux'
import { doSelectAllTickets } from 'actions/app'
import {
  doDeleteSelectedTickets,
  doBulkSpamSelectedTickets,
  doBulkUnreadSelectedTickets,
  doUnmarkBulkSelectionMode,
} from 'actions/tickets'
import { selectSelectedTicketIds } from 'selectors/ticket_list/base'
import { selectSearchEntityIdsByCurrentQueryId } from 'ducks/searches/selectors'
import { selectCurrentConversationsById } from 'ducks/tickets/selectors'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors'
import { isDeleted } from 'ducks/tickets/utils/state'
import DetailPane from './view'

export const select = state => {
  const selectedTicketIds = selectSelectedTicketIds(state)
  const byId = selectCurrentConversationsById(state)
  return {
    shownTicketCount: selectSearchEntityIdsByCurrentQueryId(state).length || 0,
    ticketIds: selectedTicketIds,
    showDeleteButton:
      selectCurrentUserIsAdminOrOwner(state) ||
      selectedTicketIds.some(id => {
        const ticket = byId[id]
        return ticket && !isDeleted(ticket)
      }),
  }
}
const perform = {
  onCancel: doUnmarkBulkSelectionMode,
  onDeleteClick: doDeleteSelectedTickets,
  onMarkAsSpamClick: doBulkSpamSelectedTickets,
  onMarkAsUnreadClick: doBulkUnreadSelectedTickets,
  onSelectAllShown: doSelectAllTickets,
}

export default connect(select, perform)(DetailPane)
